import React from "react";
import { Button, Card, Form, Image, Input, Layout, Row, message } from 'antd';

import logo from '../assets/images/newlogo.png';
import { Link, Navigate } from "react-router-dom";
import { POST_API, setToken } from "../services/hello-api";

class Cadastrase extends React.Component {

    state = { _navigate: false }

    onSend = (values) => {

        POST_API('/credential/cadastrar.php', { token: 'X', master: JSON.stringify(values) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                message.success(res.msg)
                setToken(res.token)
                this.setState({_navigate: true})
            } else {
                message.warning(res.msg)
            }
        }).catch(() => message.error('Servidor indisponível'))

    }

    render = () => {

        if (this.state._navigate) {
            return (<Navigate to=".." />);
        }
        
        return (
            <Layout>
                <Layout.Content className="login-content">
                    <Row className="login-row" justify={'center'} align={'middle'}>
                        <Card className="login-card">
                            <Image src={logo} className="login-image" preview={false} />
                            <Form layout="vertical" onFinish={this.onSend}>
                                <Form.Item name="NAME" className="form-input" rules={[{required: true, message: 'Campo obrigatório'}]}>
                                    <Input placeholder="Nome" />
                                </Form.Item>
                                <Form.Item name="LOGIN" className="form-input" rules={[{required: true, message: 'Campo obrigatório'}]}>
                                    <Input placeholder="E-mail" />
                                </Form.Item>
                                <Form.Item name="PASSWORD" className="form-input" rules={[{required: true, message: 'Campo obrigatório'}]}>
                                    <Input.Password placeholder="Senha" />
                                </Form.Item>
                                <Form.Item name="CODE_EVENT" className="form-input" rules={[{required: true, message: 'Campo obrigatório'}]}>
                                    <Input placeholder="Código do Evento" />
                                </Form.Item>
                                <Button htmlType="submit" shape="round" type="primary" block className="login-button">Cadastrar-se</Button>
                                <Link to=".."><Button size="small" type="link" block className="login-link">Voltar</Button></Link>
                            </Form>
                        </Card>
                    </Row>
                </Layout.Content>
            </Layout>
        )
    }

}

export default Cadastrase;